import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { useConfig } from '../../../../../../app/configcontext';
import ProtectedPaymentRoute from '../../../../../auth/Auth';
import { update_business_bookkeeping } from '../../../../../../features/business/businessSlice';

export default function BankDetails() {
  ProtectedPaymentRoute();

  const dispatch = useDispatch();
  const business = useSelector((state) => state.business);
  const config = useConfig();
  const businessTypeId = business.businessTypeId;
  const lzbooking = config?.lzBookKeeping || [];
  const navigate = useNavigate();

  useEffect(() => {
    localStorage.setItem("accessForInvoice", "1");
  }, []);

  const handleClick = (id) => {
    dispatch(update_business_bookkeeping(id));
    if (businessTypeId === 1) {
      navigate('/foundkit');
    } else {
      navigate('/invoice');
    }
  };

  const handleSkip = () => {
    dispatch(update_business_bookkeeping(null));
    if (businessTypeId === 1) {
      navigate('/foundkit');
    } else {
      navigate('/invoice');
    }
  };

  const backbtn = () => {
    if (businessTypeId === 1) {
      navigate("/report");
    } else {
      navigate("/package");
    }
  };

  return (
    <div className="min-h-[75vh] bg-[#f8f9fa] py-12 lg:py-20 font-sans">
      <div className="container mx-auto px-4 lg:px-8 max-w-6xl">
        
        {/* Header */}
        <div className="mb-12 text-center max-w-3xl mx-auto">
          <span className="text-[#1a73e8] font-semibold tracking-wider uppercase text-xs mb-2 block">
            Financial Management & Accounting
          </span>
          <h1 className="text-3xl sm:text-4xl font-normal text-[#202124] tracking-tight mb-3">
            Save time & money with dedicated bookkeeping
          </h1>
          <p className="text-[15px] text-[#5f6368] leading-relaxed">
            Easily manage your finances with automated expense tracking, professional invoicing, and real-time reporting to maximize tax deductions.
          </p>
        </div>

        {/* Bookkeeping Cards Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-4xl mx-auto mb-16">
          {lzbooking.map((ele) => (
            <div
              key={ele.name}
              className="p-8 sm:p-10 rounded-[16px] border border-[#dadce0] bg-white shadow-sm hover:border-[#1a73e8] hover:shadow-md transition-all flex flex-col justify-between"
            >
              <div>
                <div className="w-12 h-12 rounded-xl bg-[#e8f0fe] flex items-center justify-center text-[#1a73e8] text-xl mb-6 shadow-xs">
                  <i className="fa-solid fa-building-columns" aria-hidden="true"></i>
                </div>
                <h3 className="text-2xl font-medium text-[#202124] mb-3 leading-snug">{ele.name}</h3>
                <p className="text-[14.5px] text-[#5f6368] leading-relaxed mb-8">
                  {ele.description}
                </p>
              </div>

              <button
                type="button"
                onClick={() => handleClick(ele.id)}
                className="w-full py-3.5 rounded-[6px] bg-[#1a73e8] hover:bg-[#1557b0] !text-white font-medium shadow-sm transition-all text-[15px] cursor-pointer flex items-center justify-center gap-2"
              >
                <span>Select Solution</span>
                <i className="fa-solid fa-arrow-right text-xs"></i>
              </button>
            </div>
          ))}
        </div>

        {/* Footer Actions */}
        <div className="flex flex-col sm:flex-row items-center justify-between gap-4 pt-6 border-t border-[#dadce0] max-w-6xl mx-auto">
          <button
            type="button"
            onClick={backbtn}
            className="px-6 py-2.5 rounded-[4px] border border-[#dadce0] text-[#1a73e8] font-medium hover:bg-[#f1f3f4] bg-white transition-colors flex items-center gap-2 cursor-pointer text-[14px]"
          >
            <i className="fa-solid fa-arrow-left text-xs"></i> Back
          </button>
          <button
            type="button"
            onClick={handleSkip}
            className="text-[14px] text-[#5f6368] hover:text-[#1a73e8] underline transition-colors cursor-pointer bg-transparent border-none"
          >
            Skip bookkeeping for now
          </button>
        </div>

      </div>
    </div>
  );
}